import { ModelBase } from 'store/model-base';

export class InsuranceElibility extends ModelBase {
    public static storeName: string = 'insuranceElibility';

    public eligiblePlans: EligiblePlan[];
    public canShowElibilityBanner: boolean;


    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: InsuranceElibility = super.create<InsuranceElibility>(initData);

        if (toReturn.eligiblePlans.length > 0) {
            toReturn.canShowElibilityBanner = toReturn.eligiblePlans.some((plan: EligiblePlan) => plan.eligibleLines.some((line: EligibleLine) => line.status === 'ACTIVE'));
        }

        return super.create<T>(toReturn);
    }
}
